/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListMcpServerToolFiltersSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListMcpServerToolFiltersSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListMcpServerToolFiltersSecurity = {
  option1?: ListMcpServerToolFiltersSecurityOption1 | undefined;
  option2?: ListMcpServerToolFiltersSecurityOption2 | undefined;
};

export type ListMcpServerToolFiltersRequest = {
  /**
   * The ID of the MCP server. Mutually exclusive with slug.
   */
  id?: string | undefined;
  /**
   * The slug of the MCP server. Mutually exclusive with id.
   */
  slug?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListMcpServerToolFiltersSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListMcpServerToolFiltersSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListMcpServerToolFiltersSecurityOption1$Outbound,
    ListMcpServerToolFiltersSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listMcpServerToolFiltersSecurityOption1ToJSON(
  listMcpServerToolFiltersSecurityOption1:
    ListMcpServerToolFiltersSecurityOption1,
): string {
  return JSON.stringify(
    ListMcpServerToolFiltersSecurityOption1$outboundSchema.parse(
      listMcpServerToolFiltersSecurityOption1,
    ),
  );
}

/** @internal */
export type ListMcpServerToolFiltersSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListMcpServerToolFiltersSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListMcpServerToolFiltersSecurityOption2$Outbound,
    ListMcpServerToolFiltersSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listMcpServerToolFiltersSecurityOption2ToJSON(
  listMcpServerToolFiltersSecurityOption2:
    ListMcpServerToolFiltersSecurityOption2,
): string {
  return JSON.stringify(
    ListMcpServerToolFiltersSecurityOption2$outboundSchema.parse(
      listMcpServerToolFiltersSecurityOption2,
    ),
  );
}

/** @internal */
export type ListMcpServerToolFiltersSecurity$Outbound = {
  Option1?: ListMcpServerToolFiltersSecurityOption1$Outbound | undefined;
  Option2?: ListMcpServerToolFiltersSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListMcpServerToolFiltersSecurity$outboundSchema: z.ZodMiniType<
  ListMcpServerToolFiltersSecurity$Outbound,
  ListMcpServerToolFiltersSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListMcpServerToolFiltersSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListMcpServerToolFiltersSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listMcpServerToolFiltersSecurityToJSON(
  listMcpServerToolFiltersSecurity: ListMcpServerToolFiltersSecurity,
): string {
  return JSON.stringify(
    ListMcpServerToolFiltersSecurity$outboundSchema.parse(
      listMcpServerToolFiltersSecurity,
    ),
  );
}

/** @internal */
export type ListMcpServerToolFiltersRequest$Outbound = {
  id?: string | undefined;
  slug?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListMcpServerToolFiltersRequest$outboundSchema: z.ZodMiniType<
  ListMcpServerToolFiltersRequest$Outbound,
  ListMcpServerToolFiltersRequest
> = z.pipe(
  z.object({
    id: z.optional(z.string()),
    slug: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listMcpServerToolFiltersRequestToJSON(
  listMcpServerToolFiltersRequest: ListMcpServerToolFiltersRequest,
): string {
  return JSON.stringify(
    ListMcpServerToolFiltersRequest$outboundSchema.parse(
      listMcpServerToolFiltersRequest,
    ),
  );
}
